export const notifyConstants = {
    ENQUEUE_SNACKBAR : 'ENQUEUE_SNACKBAR',
    CLOSE_SNACKBAR : 'CLOSE_SNACKBAR',
    REMOVE_SNACKBAR : 'REMOVE_SNACKBAR'
};